<template>
  <div>
    <h3>选择分类</h3>
    <!-- <h5>点击即可选择</h5> -->
    <box-header>
      <!-- <Row slot="left">
        <Button type="error" icon="ios-close-circle-outline" @click="clear"
          >清除选择</Button
        >
      </Row> -->
      <Row slot="right">
        <!-- <Select
          placeholder="分类"
          @on-change="search"
          v-model="query.model"
          style="width: 200px"
        >
          <Option
            v-for="item in cityList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select> -->
        <!-- <Input
          placeholder="分类"
          style="width: 200px"
          search
          v-model="query.model"
          @on-search="search"
          @on-enter="search"
        /> -->
        <Input
          placeholder="标题"
          style="width: 200px; margin-right: 10px"
          v-model="query.name"
          @on-search="search"
          @on-enter="search"
        />
        <Button style="margin-right: 10px" @click="clearall">重置</Button>
        <Button type="info" style="margin-right: 10px" @click="search"
          >查询</Button
        >
        <Button type="error" @click="clear">清空选择</Button>
      </Row>
    </box-header>
    <Row>
      <div style="width: 648px">
        <Table
          @on-select="handleSelect"
          ref="tablelist"
          size="default"
          :output="false"
          :query="query"
          height="520"
          :data="thisTableData"
          :columns="tableCols"
          @on-select-cancel="selectcancel"
          @on-select-all="selectall"
          @on-select-all-cancel="selectallcancel"
          @on-click="clickRow"
        ></Table>
      </div>
      <Row span="24">
        <div
          style="
            width: 648px;
            display: flex;
            justify-content: flex-end;
            margin-top: 5px;
          "
        >
          <Page
            :total="page.total"
            :current="page.page"
            :page-size="page.psize"
            :page-size-opts="[10, 20, 30, 50, 100, 200, 500, 1000, 2000]"
            show-total
            :show-elevator="getWindowWidth() > 480 ? false : false"
            :show-sizer="getWindowWidth() > 480 ? true : false"
            @on-change="changePage"
            @on-page-size-change="changePagesize"
          ></Page>
          <!-- <Button type="info" @click="ok">确定</Button> -->
        </div>
      </Row>
    </Row>
  </div>
</template>
<script>
export default {
  name: "pop",
  components: {},
  props: {
    value: String | Number,
    name: String,
    // query: {
    //   type: Object,
    //   default: () => {
    //     return {
    //       model: "",
    //       name: "",
    //       // user_mobile: "",
    //     };
    //   },
    // },
  },
  data() {
    return {
      query: {
        model: "",
        name: "",
      },
      thisTableData: [],
      page: {
        p: 1,
        psize: 10,
        total: 10,
      },
      // url: "/admin/api/content/list",
      //   query: {
      //     // 用props的query替换
      //   },
      table: {
        tname: "",
        key: "category_id",
        url: {
          // list: "contentnotPagelist",
          list: "showbaseCategory",
        },
      },
      tableCols: [
        {
          type: "selection",
          key: "_isChecked",
          align: "center",
        },
        {
          title: "id",
          key: "category_id",
          align: "center",
        },
        {
          title: "标题",
          key: "name",
        },
      ],
      thisselect: [],
      pagelist: [],
    };
  },
  watch: {
    value(v) {
      // console.log(v);
      this.thisselect = v || [];
      // this.search()
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.search();
  },
  methods: {
    clearall() {
      this.query.model = "";
      this.query.name = "";
      this.init();
    },
    init() {
      let q = {};
      q.page = this.page.p;
      q.psize = this.page.psize;
      q.order = this.order;
      q.query = this.query;
      // q.query.status = 1;
      $utils.api.load(`showbaseCategory`, q, "get").then((res) => {
        // console.log(res, this.thisselect,"222222");
        if (res && res.data) {
          this.pagelist = res.data.list || res.data || [];
          const kk = res.data.list || res.data || [];
          this.thisselect.map((item) => {
            for (let index in kk) {
              // console.log(kk[index]);
              if (item == kk[index].category_id) {
                // 依次对比
                kk[index]._checked = true;
                // console.log(kk[index]._checked);
              }
            }
          });
          // console.log(kk);
          this.thisTableData = kk;
          this.page = res.data.page;
        }
      });
    },
    handleSelect(selected, row) {
      // this.$emit("on-select", this.selected);
      this.thisselect.push(row.category_id);
      this.$emit("on-select", this.thisselect);
      // console.log("handleSelect", this.thisselect, row);
    },
    selectcancel(selection, row) {
      const newData = this.thisselect.filter((item) => {
        // console.log(item);
        if (item != row.category_id) {
          return item;
        }
      });
      // console.log("newData", newData);
      this.thisselect = newData;
      this.$emit("on-select", this.thisselect);
      // console.log("selectcancel2222", this.thisselect, row);
    },
    selectall(selection) {
      if (this.thisselect.length > 0) {
        selection.filter((item) => {
          console.log(item);
          if (this.thisselect.some((items) => item.category_id == items)) {
          } else {
            this.thisselect.push(item.category_id);
          }
        });
      } else {
        selection.map((items) => {
          this.thisselect.push(items.category_id);
        });
      }
      console.log("selectall", this.thisselect);
      this.$emit("on-select", this.thisselect);
    },
    selectallcancel(selection, row) {
      console.log("selectallcancel", this.pagelist);
      const newData = this.thisselect.filter((item) => {
        if (this.pagelist.some((items) => Number(item) == items.category_id)) {
        } else {
          console.log(item);
          return Number(item);
        }
      });
      console.log(newData);
      this.thisselect = newData;
      this.$emit("on-select", this.thisselect);
    },
    search() {
      this.init();
      // this.$refs.tablelist.init();
    },
    changePage(p) {
      // 记录表格当前页面，返回时调用
      this.page.p = p;
      // 刷新数据
      this.init();
      // console.log("page ", p);
    },
    changePagesize(psize) {
      // 刷新数据 页码置1
      this.page.p = 1;
      this.page.psize = psize;
      this.init();
      // console.log("page size ", psize);
    },
    clear() {
      // console.log(this.$refs.tablelist); // 18 , 30
      this.$refs.tablelist.selectAll(false);
      this.$emit("on-clear", null);
    },
    ok() {
      this.$emit("on-ok", null);
    },
    getWindowWidth() {
      return window.innerWidth;
    },
    // clickRow(row, index) {
    //   this.$emit("on-click", row);
    // },
  },
};
</script>
<style lang="less">
</style>


